import { render, staticRenderFns } from "./shipping-zones-form.vue?vue&type=template&id=350c5d70&"
import script from "./shipping-zones-form.vue?vue&type=script&lang=js&"
export * from "./shipping-zones-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports